import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import ArrFunc from '@/lib/lyg/arr_func';
import { useSelector, useDispatch } from 'react-redux';
import DiscoverMapDataFunc from "@/pcomponents/common/content/edu/discover_map/func/data_func";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import { useReactToPrint } from 'react-to-print';
import WriteArea from "./area/write_area";
import ListHistoryArea from "./area/list_history";

const DisCoverMapWriteArea = forwardRef((props: any, ref) => {
  let myProps = {
    select_mcomp_data: {
      mcomp_seq: "",
      api_key: "",
      api_user_seq: "",
    },
    list: (inOptObj: any) => { },
    is_view_mode: true,
    is_show_history: true,
    is_show_pre_view_right: true,
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let now_ymd = DateFunc.get_date_format(new Date(), "Ymd");
  let now_y_m_d = DateFunc.get_date_format(new Date(), "Y-m-d");
  let default_info_data = {
    ...DiscoverMapDataFunc.default_info_data,
    a_ymd: now_ymd,
    a_seq: "",
    a_date: now_y_m_d,
    a_writer_seq: user.user_seq,
    a_writer: user.user_name,
    a_is_req_prescribe: "",
  };
  const [info, set_info] = useState<any>({ ...default_info_data });
  const [pre_info, set_pre_info] = useState<any>({ ...default_info_data });
  const [pre_info_idx, set_pre_info_idx] = useState(0);
  const [info_arr, set_info_arr] = useState([]);
  const [stu_info, set_stu_info] = useState<any>({});
  const [is_update, set_is_update] = useState(false);
  const [is_view_mode, set_is_view_mode] = useState(myProps.is_view_mode);
  const [select_mcomp_data, set_select_mcomp_data] = useState(myProps.select_mcomp_data);
  const default_list_opt = {
    s_date_type: "a_date",
    s_start_date: "",
    s_end_date: "",
    s_stu_seq: "",
    order_id: "a_date DESC, a_create_date DESC",
    s_addon_daily_report_en_math: "1",
    s_addon_user: "1",
    "is_need_count": "",
    "is_need_info_arr": "1",
    "is_no_limit": "1",

    select_pri_seq: "",
  };
  const [list_opt, set_list_opt] = useState({
    ...default_list_opt
  });
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const printRef2 = useRef(null);
  const onClickPrint2 = useReactToPrint({
    content: () => printRef2.current,
  });

  let stu_grade_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade' });

  useEffect(() => {

  }, []);

  const initData = (inData: any) => {
    let opt_obj = {
      select_mcomp_data: select_mcomp_data,
      stu_seq: stu_info ? stu_info["a_seq"] : "",
      info: info,
      is_update: false,
      is_view_mode: is_view_mode,
      list_opt: { ...list_opt },
      ...inData
    };
    let change_row_info: any = {
      ...DiscoverMapDataFunc.default_info_data,
      ...opt_obj.info,
      a_writer_seq: user.user_seq,
      a_writer: user.user_name,
    };
    if (opt_obj.stu_seq) {
      get_stu_info_by_ajax({
        stu_seq: opt_obj.stu_seq,
        is_update: opt_obj.is_update,
        select_mcomp_data: opt_obj.select_mcomp_data,
        info: opt_obj.info,
        list_opt: opt_obj.list_opt
      });
    } else {
      set_stu_info({});
      return false;
    }
    opt_obj.list_opt = {
      ...default_list_opt,
      ...list_opt,
      ...opt_obj.list_opt
    };
    if (!strFunc.is_empty(change_row_info.a_seq)) {
      opt_obj.is_update = true;
    } else {
      opt_obj.is_update = false;
    }
    set_info(change_row_info);
    set_is_update(opt_obj.is_update);
    set_is_view_mode(opt_obj.is_view_mode);
    set_select_mcomp_data(opt_obj.select_mcomp_data);
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    initData
  }));

  const get_discover_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      list_opt: list_opt,
      select_mcomp_data: select_mcomp_data,
      is_update: is_update,
      select_pri_seq: "",
      ...inData,
    };
    let change_list_opt = {
      ...list_opt,
      select_mcomp_data: select_mcomp_data,
      ...inData.list_opt
    };
    set_list_opt(change_list_opt);
    if (strFunc.is_empty(change_list_opt["s_stu_seq"])) {
      set_pre_info({ ...default_info_data });
      set_pre_info_idx(0);
      return false;
    }
    if (!strFunc.is_empty(opt_obj.select_mcomp_data.api_key)
      && !strFunc.is_empty(opt_obj.select_mcomp_data.api_user_seq)) {
      change_list_opt["api_key"] = opt_obj.select_mcomp_data.api_key;
      change_list_opt["api_user_seq"] = opt_obj.select_mcomp_data.api_user_seq;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/discover_map/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let tmp_info_arr = response.data["data"]["info_arr"];
          if (tmp_info_arr.length > 0) {
            if (opt_obj.is_update && strFunc.is_empty(opt_obj["select_pri_seq"])) {
              set_info(tmp_info_arr[0]);
            } else {
              for (let i = 0; i < tmp_info_arr.length; i++) {
                let tmp_info = tmp_info_arr[i];
                let tmp_row_pri_val = tmp_info["a_ymd"] + "," + tmp_info["a_seq"];
                if (tmp_row_pri_val == opt_obj["select_pri_seq"]) {
                  set_info(tmp_info);
                  break;
                }
              }
            }
            let tmp_pre_idx = 0;
            if (tmp_info_arr.length >= 2) {
              tmp_pre_idx = 1;
            }
            set_pre_info_idx(tmp_pre_idx);
            set_pre_info(tmp_info_arr[tmp_pre_idx]);
          } else {
            set_is_update(false);
            set_pre_info({ ...default_info_data });
            set_pre_info_idx(0);
          }
          set_info_arr(response.data["data"]["info_arr"]);
        }
      });
  };

  const get_stu_info_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_seq: "",
      is_update: is_update,
      select_mcomp_data: select_mcomp_data,
      list_opt: list_opt,
      info: info,
      ...inData
    };
    if (strFunc.is_empty(opt_obj.stu_seq)) {
      return false;
    }
    let formJsonData: any = {
      "s_seq": [opt_obj.stu_seq],
      "s_addon_add_memo": "1",
      "s_addon_daily_report_last": "1",
      // s_addon_discover_map: "1",
      // s_addon_discover_map_start_date: "",
      // s_addon_discover_map_end_date: "",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    if (!strFunc.is_empty(select_mcomp_data.api_key)
      && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
      formJsonData["api_key"] = select_mcomp_data.api_key;
      formJsonData["api_user_seq"] = select_mcomp_data.api_user_seq;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let user_info = response.data["data"]["info_arr"][0];
            set_stu_info(user_info);

            if (strFunc.is_empty(opt_obj.info["a_seq"])) {
              let change_dis_info = DiscoverMapDataFunc.get_info_of_stu_by_stu_info({
                info: opt_obj.info,
                stu_info: user_info,
                stu_grade_option_arr: stu_grade_option_arr,
              });
              set_info(change_dis_info);
            }

            let select_pri_seq = "";
            if (opt_obj.stu_seq) {
              opt_obj.list_opt["s_stu_seq"] = opt_obj.stu_seq;
              if (opt_obj.info["a_seq"]) {
                select_pri_seq = opt_obj.info["a_ymd"] + "," + opt_obj.info["a_seq"];
              }
              opt_obj.list_opt.select_mcomp_data = opt_obj.select_mcomp_data;
              get_discover_arr_by_ajax({
                list_opt: opt_obj.list_opt,
                select_mcomp_data: opt_obj.select_mcomp_data,
                is_update: opt_obj.is_update,
                select_pri_seq: select_pri_seq,
              });
            }
          }
        }
      });
  };

  const plus_minus_pre_info_idx = (inData: any) => {
    let opt_obj = {
      info_arr: info_arr,
      select_idx: pre_info_idx,
      sort: "+",//+,-
      ...inData
    };
    let select_idx = ArrFunc.get_idx_of_plus_minus({
      max_len: opt_obj.info_arr.length,
      idx: opt_obj.select_idx,
      sort: opt_obj.sort,//+,-
    });
    set_pre_info_idx(select_idx);
    let tmp_select_info = ArrFunc.get_info_of_arr_by_idx({
      info_arr: opt_obj.info_arr,
      idx: select_idx,
    });
    set_pre_info({
      ...default_info_data,
      ...tmp_select_info
    });
  };

  const onClickPrint = () => {
    if (printRef.current) {
      handlePrint();
    }
  };

  const write_by_ajax = (inData: any) => {
    let opt_obj = {
      info: info,
      ...inData
    };
    let row_data = opt_obj.info;

    if (strFunc.is_empty(row_data["a_date"])) {
      alert("날짜를 입력해주세요.");
      return false;
    }
    if (strFunc.is_empty(row_data["a_stu_seq"])) {
      alert("학생선택이 필요합니다.");
      return false;
    }
    if (confirm("저장하시겠습니까?") == false) {
      return false;
    }
    let w_info: any = {
      ...row_data
    };
    if (!strFunc.is_empty(row_data["a_seq"])) {
      if (row_data["a_writer_seq"] != user.user_seq) {
        w_info["a_reviewer_seq"] = user.user_seq;
        w_info["a_reviewer"] = user.user_name;
      }

    }
    if (strFunc.is_empty(row_data["a_seq"])) {
      w_info["a_ymd"] = DateFunc.get_date_format(new Date(row_data["a_date"]), "Ymd");
    }
    let from_json_data: any = {
      data_arr: [w_info],
    };
    if (strFunc.is_empty(row_data["a_seq"])) {
      from_json_data["is_default_val"] = "1";
    }
    if (!strFunc.is_empty(select_mcomp_data.api_key)
      && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
      from_json_data["api_key"] = select_mcomp_data.api_key;
      from_json_data["api_user_seq"] = select_mcomp_data.api_user_seq;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/discover_map/write', from_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("저장 되었습니다.");
          myProps.list({});

          initData({
            stu_seq: stu_info["a_seq"],
            info: response.data["data"][0],
            info_arr: response.data["data"],
            is_update: true,
          });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_success_by_ajax = (inData: any) => {
    let opt_obj = {
      info: {},
      is_success: true,
      ...inData
    };
    let confirm_msg = "처방완료 하시겠습니까?";
    if (opt_obj.is_success == false) {
      confirm_msg = "처방완료를 취소 하시겠습니까?";
    }
    if (confirm(confirm_msg) == false) {
      return false;
    }

    let w_info: any = {
      ...info
    };
    if (opt_obj.is_success) {
      w_info["a_is_success"] = "1";
      w_info["a_success_date"] = DateFunc.get_date_format(new Date(), "Y-m-d h:i:s");
      w_info["a_reviewer_seq"] = user.user_seq;
      w_info["a_reviewer"] = user.user_name;
    } else {
      w_info["a_is_success"] = "";
    }

    let from_json_data: any = {
      data_arr: [w_info],
      is_update: "1"
    };
    if (!strFunc.is_empty(select_mcomp_data.api_key)
      && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
      from_json_data["api_key"] = select_mcomp_data.api_key;
      from_json_data["api_user_seq"] = select_mcomp_data.api_user_seq;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/discover_map/write', from_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("변경 되었습니다.");
          set_info(w_info);
          myProps.list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const delete_by_ajax = (inData: any) => {
    let opt_obj = {
      del_info: {},
      ...inData
    };
    let del_info = opt_obj.del_info;
    if (strFunc.is_empty(del_info["a_seq"])) {
      alert("데이터 키가 없습니다.");
      return false;
    }

    if (confirm("삭제하시겠습니까?") == false) {
      return false;
    }

    let from_json_data: any = {
      data_arr: [del_info],
    };
    if (!strFunc.is_empty(select_mcomp_data.api_key)
      && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
      from_json_data["api_key"] = select_mcomp_data.api_key;
      from_json_data["api_user_seq"] = select_mcomp_data.api_user_seq;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/discover_map/delete', from_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("삭제 되었습니다.");
          myProps.list({});
          let del_pri_val = del_info["a_ymd"] + "," + del_info["a_seq"];
          let new_info_arr: any = [];
          for (let i = 0; i < info_arr.length; i++) {
            let tmp_info = info_arr[i];
            let tmp_row_pri_val = tmp_info["a_ymd"] + "," + tmp_info["a_seq"];
            if (tmp_row_pri_val != del_pri_val) {
              new_info_arr.push(tmp_info);
            }
          }
          if (new_info_arr.length > 0) {
            initData({
              stu_seq: stu_info["a_seq"],
              info: new_info_arr[0],
              info_arr: new_info_arr,
              is_update: true,
              is_view_mode: true,
            });
          } else {
            initData({
              stu_seq: stu_info["a_seq"],
              info: {},
              info_arr: new_info_arr,
              is_update: false,
              is_view_mode: true,
            });
          }
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  let print_page_style: any = { padding: "20px", background: "#fff" };
  let a4subpage_style: any = {
    height: "auto",
    minHeight: "285mm",
  };

  return (
    <div style={{ background: "#ededed", paddingTop: "2px" }}>
      <div className="ml-1" style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
        <div style={{width: "21cm",margin:"0 auto"}}>
          <div className="text-center" style={{ width: "21cm" }}>
            {(is_view_mode == false && !strFunc.is_empty(stu_info.a_seq)) &&
              <span>
                <button className={"ml-1 btn btn-" + (is_update ? "yellowish2" : "dark")} onClick={() => { write_by_ajax({}); }} >
                  {info.a_is_req_prescribe == "1" ? "저장" : "임시저장"}
                </button>
                {info.a_is_req_prescribe != "1" &&
                  <button className="btn btn-yellowish2 ml-1"
                    onClick={() => {
                      let change_info = {
                        ...info,
                        a_is_req_prescribe: "1",
                        a_req_prescribe_date: DateFunc.get_date_format(new Date(), "Y-m-d h:i:s"),
                      };
                      write_by_ajax({
                        info: change_info
                      });
                    }} >
                    처방요청
                  </button>
                }
              </span>
            }
            {(is_update && !strFunc.is_empty(stu_info.a_seq) && info.a_is_req_prescribe == "1") &&
              <span>
                {info["a_is_success"] != "1" ?
                  <button className="btn btn-blue ml-1"
                    onClick={() => { go_success_by_ajax({ is_success: true }); }}>처방완료</button>
                  :
                  <button className="btn btn-gray ml-1"
                    onClick={() => { go_success_by_ajax({ is_success: false }); }}>완료취소</button>
                }
              </span>
            }
            {strFunc.is_empty(stu_info.a_seq) ? "학생 선택이 필요합니다." :
              <span>
                <button className="btn btn-dark ml-1" onClick={() => { set_is_view_mode(!is_view_mode); }}>
                  {is_view_mode ? "수정모드" : "보기모드"}
                </button>
              </span>
            }
            <button className="btn btn-gray ml-1" onClick={() => { onClickPrint(); }}>프린트</button>
            {is_update &&
              <button className="btn btn-sky ml-1" onClick={() => {
                initData({
                  info: { ...default_info_data },
                  is_view_mode: false,
                  is_update: false,
                });
              }}>신규등록</button>
            }
          </div>
          <div className="border mt-1" style={{ display: "inline-block" }}>
            <div className="a4page" ref={printRef} style={print_page_style} >
              <div className="a4subpage" style={a4subpage_style}>
                <WriteArea
                  info={info}
                  set_info={set_info}
                  stu_info={stu_info}
                  is_view_mode={is_view_mode}
                ></WriteArea>
              </div>
            </div>
            작성시간: {info["a_create_date"]}
            {info.a_is_success == "1" &&
              <span className="ml-2">처방완료:{info["a_success_date"]}</span>
            }
          </div>
        </div>
        {myProps.is_show_pre_view_right &&
          <div>
            <div className="text-center" style={{ width: "21cm" }}>
              이전데이터:
              <button className="btn btn-dark ml-1" onClick={() => { set_info(pre_info); set_is_update(true); }}>◁선택</button>
              <button className="btn btn-dark ml-1" onClick={() => { plus_minus_pre_info_idx({ "sort": "-" }); }}>
                ◀
              </button>
              {info_arr.length > 0 &&
                <span className="ml-1">{pre_info_idx + 1}/{info_arr.length}</span>
              }
              <button className="btn btn-dark ml-1" onClick={() => { plus_minus_pre_info_idx({ "sort": "+" }); }}>
                ▶
              </button>
              <button className="btn btn-gray ml-1" onClick={() => { onClickPrint2(); }}>프린트</button>
            </div>
            <div className="border mt-1" style={{ display: "inline-block" }}>
              <div className="a4page" ref={printRef2} style={print_page_style} >
                <div className="a4subpage" style={a4subpage_style} >
                  <WriteArea
                    info={pre_info}
                    stu_info={stu_info}
                    is_view_mode={true}
                  ></WriteArea>
                </div>
              </div>
              작성시간: {pre_info["a_create_date"]}
              {pre_info.a_is_success == "1" &&
                <span className="ml-2">처방완료:{pre_info["a_success_date"]}</span>
              }
            </div>
          </div>
        }
      </div>
      {
        myProps.is_show_history &&
        <div className="mt-1" 
          style={{ background: "#fff", width: "21cm", margin:"0 auto" }}>
          히스토리
          <ListHistoryArea
            info={info}
            set_info={(inData: any) => {
              initData({
                stu_seq: stu_info["a_seq"],
                info: inData,
                info_arr: info_arr,
                is_update: true,
                is_view_mode: true,
              });
            }}
            info_arr={info_arr}
            delete_by_ajax={delete_by_ajax}
          ></ListHistoryArea>
        </div>
      }
    </div >
  );
});
export default DisCoverMapWriteArea;